import React, { useState, useEffect } from "react";
import logo from '../../../../components/NavigationMenu/assets/BeanbagLogo.svg'
import "./fold.css";

const AutoScrollingCarousel = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isHovered, setIsHovered] = useState(false);
  const [isVisible, setIsVisible] = useState(false);

  const stats = [
    {
      highlight: "2x Recovery Rate",
      text: "We more than doubled our recovery rate by calling abandoned carts…",
      author: "~Shopify Dropshipper",
      gradient: "from-emerald-500 to-teal-600",
      shadowColor: "rgba(16, 185, 129, 0.4)",
    },
    {
      highlight: "82% Automation",
      text: "AI voice agent handled 82% of queries, cut voicemails by 99%, and boosted sales +25%.",
      author: "~Toy Retailer",
      gradient: "from-purple-500 to-indigo-600",
      shadowColor: "rgba(139, 92, 246, 0.4)",
    },
    {
      highlight: "$5k+/Month",
      text: "Built an AI agent that calls, offers 15% off, and texts checkout links–recovered $5k+/month.",
      author: "~E-commerce Store Owner",
      gradient: "from-blue-500 to-cyan-600",
      shadowColor: "rgba(59, 130, 246, 0.4)",
    },
  ];
   const results = [
    {
      highlight: "30–35%",
      text: "recovered abandoned carts",
    },
    {
      highlight: "2x",
      text: "Recovery",
    },
    {
      highlight: "99%",
      text: "Saved",
    },
    {
      highlight: "1/3",
      text: "Revenue reclaimed",
    }
  ];

  // Auto-scroll functionality
  useEffect(() => {
    setIsVisible(true);
    if (!isHovered) {
      const interval = setInterval(() => {
        setCurrentIndex((prevIndex) => (prevIndex + 1) % stats.length);
      }, 5000);

      return () => clearInterval(interval);
    }
  }, [isHovered, stats.length]);

  const goToSlide = (index) => {
    setCurrentIndex(index);
  };

  const nextSlide = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % stats.length);
  };

  const prevSlide = () => {
    setCurrentIndex(
      (prevIndex) => (prevIndex - 1 + stats.length) % stats.length
    );
  };

  return (
    <div className={`carousel-container-two ${isVisible ? "visible-two" : ""}`}>
      {/* Animated background elements */}
      <div className="bg-decoration-two">
        <div className="floating-circle-two circle-1-two"></div>
        <div className="floating-circle-two circle-2-two"></div>
        <div className="floating-circle-two circle-3-two"></div>
      </div>

      <div className="section-header">
        <h2 className="section-title">
          <span className="title-gradient">What Our Customers Say</span>
        </h2>
        <p className="section-subtitle">
          <span className="subtitle-highlight">
            Social Proof & Testimonials
          </span>
        </p>
      </div>

      <div
        className="carousel-wrapper-two"
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      >
        {/* Animated border */}
        <div className="animated-border-two"></div>

        {/* Progress bar */}
        <div className="progress-container-two">
          <div
            className="progress-bar-two"
            style={{
              width: `${((currentIndex + 1) / stats.length) * 100}%`,
              background: `linear-gradient(90deg, ${stats[
                currentIndex
              ]?.gradient
                .replace("from-", "")
                .replace("to-", "")
                .replace("-500", "")
                .replace("-600", "")})`,
            }}
          ></div>
        </div>

        {/* Slides container */}
        <div className="carousel-slides-two">
          <div
            className="carousel-track-two"
            style={{ transform: `translateX(-${currentIndex * 100}%)` }}
          >
            {stats.map((stat, index) => (
              <div key={index} className="carousel-slide-two">
                <div
                  className={`stat-card-two ${
                    index === currentIndex ? "active-two" : ""
                  }`}
                >
                  <div className="stat-content-two">
                    <div className="stat-highlight-two">
                      <span className="highlight-text-two">
                        {stat.highlight}
                      </span>
                    </div>
                    <p className="stat-text-two">{stat.text}</p>
                    <p className="stat-author-two">{stat.author}</p>
                  </div>

                  <div className="logo-container-two">
                    <img
                      src={logo}
                      alt="Company Logo"
                      className="company-logo-two"
                    />
                  </div>

                  <div className="navigation-controls-two">
                    <button
                      className="carousel-arrow-two carousel-arrow-left-two"
                      onClick={prevSlide}
                      aria-label="Previous stat"
                    >
                      <svg
                        width="20"
                        height="20"
                        viewBox="0 0 24 24"
                        fill="none"
                      >
                        <path
                          d="M15 18L9 12L15 6"
                          stroke="currentColor"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </button>

                    <button
                      className="carousel-arrow-two carousel-arrow-right-two"
                      onClick={nextSlide}
                      aria-label="Next stat"
                    >
                      <svg
                        width="20"
                        height="20"
                        viewBox="0 0 24 24"
                        fill="none"
                      >
                        <path
                          d="M9 18L15 12L9 6"
                          stroke="currentColor"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </button>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
       <div className="results-container-four">
      <div className="results-grid-four">
        {results.map((result, index) => (
          <div key={index} className="result-box-four">
            <div className="result-text-four">{result.text}</div>
            <div className="result-highlight-four">{result.highlight}</div>
          </div>
        ))}
      </div>
    </div>

    </div>
  );
};

export default AutoScrollingCarousel;
